<template>
    <div>
        <div class="space-y-4">
            <div
                v-for="(item, index) in lineItems"
                :key="index"
                class="flex items-center justify-between min-h-[2.5rem] py-1"
                :data-test="`line-item-${index}`"
            >
                <div class="flex-1 flex flex-col justify-center">
                    <div class="text-sm text-gray-900" data-test="item-name">
                        {{ getItemName(item) }}
                    </div>
                    <div v-if="item.quantity && item.unit_amount" class="text-xs text-gray-500 mt-0.5">
                        {{ formatNumber(item.quantity) }} {{ item.quantity === 1 ? 'unit' : 'units' }} @ ${{
                            formatRate(item.unit_amount)
                        }}
                    </div>
                </div>
                <div class="text-sm font-medium text-gray-900 ml-4 tabular-nums">
                    {{ currencyCents(item.total_cents) }}
                </div>
            </div>
        </div>

        <!-- Total section -->
        <div class="mt-4 pt-4 border-t border-gray-100">
            <div class="flex justify-between items-baseline">
                <span class="text-sm text-gray-600">Estimated total</span>
                <span class="text-lg font-semibold text-gray-900 tabular-nums">{{ currencyCents(totalCents) }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { currencyCents, formatNumber } from '~/utils/helpers';

defineProps({
    totalCents: {
        type: Number,
        required: true,
    },
    lineItems: {
        type: Array,
        required: true,
    },
});

// Helper to format rate with proper decimal places
const formatRate = (rate) => {
    const formatted = parseFloat(rate.toFixed(5)).toString();
    const parts = formatted.split('.');
    if (!parts[1] || parts[1].length < 2) {
        return rate.toFixed(2);
    }
    return formatted;
};

// Get clean item name without quantity/rate info
const getItemName = (item) => {
    return item.name;
};
</script>
